// Module
var code = "<div class=\"item collection-item {{ _is_current ? 'active' : '' }}\"> <div class=\"page-name\" title=\"{{ title || '' }}\">{{ title || '' }}</div> <div class=\"controls\"> <button class=\"btn-flat icon dropdown-button\"> <span class=\"striimline-icon three-dots\"></span> </button> </div> </div> ";
// Exports
export default code;